// extracted by mini-css-extract-plugin
module.exports = {"iirgi4a":"iirgi4a","cr8g41v":"cr8g41v","c1gcnfq1":"c1gcnfq1"};